import AccessibleAutocomplete from "./lib/AccessibleAutocomplete";

let fetchedExperts: Promise<string[]>|null = null;

let expertsMapping: Record<string, string>;
function loadExperts() {
	if (fetchedExperts !== null) {
		return fetchedExperts;
	}
	const url = new URL(`/wp-json/plaudit/summitortho/v1/expert-names`, document.baseURI);
	return fetchedExperts = fetch(url, {method: 'GET'})
		.then<string[]>(async resp => {
			expertsMapping = await resp.json();
			return Object.keys(expertsMapping);
		});
}

function onExpertSelect(expert: string) {
	window.location.href = expertsMapping[expert];
}

function attachExpertsAutocomplete(element: HTMLElement) {
	if (element instanceof HTMLInputElement) {
		new AccessibleAutocomplete(element, loadExperts, undefined, onExpertSelect);
	} else {
		const input = element.querySelector('input');
		if (input) {
			new AccessibleAutocomplete(input, loadExperts, undefined, onExpertSelect);
		}
	}
}

document.querySelectorAll<HTMLElement>(".pql-experts-name-field").forEach(attachExpertsAutocomplete);
new MutationObserver(mutations => {
	for (const mutation of mutations) {
		for (const element of mutation.addedNodes) {
			if (element instanceof HTMLElement) {
				if (element.classList.contains("pql-experts-name-field")) {
					attachExpertsAutocomplete(element);
				} else {
					element.querySelectorAll<HTMLElement>(".pql-experts-name-field").forEach(attachExpertsAutocomplete);
				}
			}
		}
	}
}).observe(document.body, {subtree: true, childList: true});
